import ErrorIcon404 from '../../assets/svg/ErrorIcon404'
import AccessDenied from '../../components/AccessDenied/AccessDenied'

const PageNotFound = () => {
    return (
        <AccessDenied text={'Page Not Found'} subText={'Sorry the page you requested was not found. Please check the URL or click on the link bellow to go back home.'} btnText={'GO BACK'}>
            <ErrorIcon404/>
        </AccessDenied>
    )
}

export default PageNotFound